import * as React from "react";

import { cn } from "@/lib/utils";
import { Button } from "@/components/ui/button";

interface SpecialCTAProps extends React.ComponentProps<typeof Button> {
  children: React.ReactNode;
  onClick: () => void;
  active?: boolean;
  disabled?: boolean;
}

export function SpecialCTA({ active, onClick, children, className, disabled, size = "sm", ...props }: SpecialCTAProps) {
  return (
    <div className="flex items-center justify-center">
      <span
        className={cn(
          "group/special inline-block rounded-[10px] p-0.5 transition-colors ease-in",
          !disabled ? "cursor-pointer" : "cursor-not-allowed opacity-50",
          disabled
            ? "bg-muted"
            : active
            ? "bg-gradient-to-bl from-cyan-400 to-pink-400 dark:from-cyan-700 dark:to-pink-700"
            : cn(
                "bg-gradient-to-tr from-cyan-500 to-pink-500 dark:from-cyan-900 dark:to-pink-900",
                "hover:bg-gradient-to-bl hover:from-cyan-400 hover:to-pink-400 dark:hover:from-cyan-700 dark:hover:to-pink-700",
              ),
        )}
      >
          <Button
            onClick={onClick}
            className={cn(
              "cursor-pointer w-auto justify-center transition-colors ease-in",
              className,
              `${active ? 'bg-background' : ''}`,
              'hover:bg-background'
            )}
            variant="secondary"
            size={size}
            disabled={disabled}
            {...props}
          >
            {children}
          </Button>
      </span>
    </div>
  );
}
